import styled from "styled-components";
import { Table } from "antd";

export const StyledTable = styled(Table)`
  &.ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent;
  }
`;
